<script>
export default {
  name: "search",
  props: ["listLength"],
  data() {
    return {
      keywordInput: "",
      page: 1,
      firstPage: 0,
      lastPage: 0
    };
  },
  methods: {
    toSearch() {
      let query = {
        q: this.keywordInput,
        page: this.page
      };
      this.$emit("search", query);
    },
    getPrePage() {
      if (this.page == 1) return;
      this.page = this.page - 1;
      let query = {
        q: this.keywordInput,
        page: this.page
      };
      this.$emit("getPrePage", query);
    },
    getNextPage() {
      if (this.lastPage >= this.listLength) return;
      if (this.lastPage == 30) this.firstPage = 1;
      this.page = this.page + 1;

      let query = {
        q: this.keywordInput,
        page: this.page
      };
      this.$emit("getNextPage", query);
    }
  },
  mounted() {
    this.firstPage = 1 + (this.page - 1) * 30;
    this.lastPage = this.page * 30;
  },
  watch: {
    page(val) {
      this.firstPage = 1 + (val - 1) * 30;
      this.lastPage = val * 30;
      if (this.lastPage > this.listLength) this.lastPage = this.listLength;
    },
    listLength(val) {
      this.page = 1;
      this.firstPage = 1;
      this.lastPage = 30;
      if (this.lastPage > this.listLength || this.listLength < 30) {
        this.lastPage = val;
        return;
      }
      // //當列表總長超過 30 ，但顯示結果還是要顯示 lastPage 為 30
      // if (val > 30) this.lastPage = 30;
      // if (val < 30) this.firstPage = 1;
    }
  }
};
</script>


<template src="./template.html"></template>
<style lang="scss" src="./style.scss" scoped />
